export default "__VITE_ASSET__5f7670de__"